function ProgramModal(el) {
    this.el = el;

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) {
            e.preventDefault();
            this.hide();
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });
}

ProgramModal.prototype.show = function() {
    this.el.classList.add('visible');
};

ProgramModal.prototype.hide = function() {
    this.el.classList.remove('visible');
};


(function() {
    const programModalEl = document.querySelector('.jsProgramModal');

    if (programModalEl) {
        const programModal = new ProgramModal(programModalEl);

        document.addEventListener('click', e => {
            if (e.target.classList.contains('jsShowProgramModal')) {
                e.preventDefault();
                programModal.show();
            }
        });
    }
})();
